<script>
import firebase from 'firebase/app'

export default {
  props: {
    item: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      taps: 0,
      canBeLiked: true,
      showHeart: false,
      gModeTaps: null,
    }
  },
  computed: {
    alreadyLiked() {
      return this.item.likes.includes(this.$store.state.users.user)
    },
    url() {
      const maxWidth = 700
      const width = window.innerWidth > maxWidth ? maxWidth : window.innerWidth

      // const maxHeight = 1000
      // const height = window.innerHeight > maxHeight ? maxHeight : window.innerHeight
      return `url(https://ik.imagekit.io/shnapme/tr:w-${width},q-70/${
        this.item.filename
      })`
    },
  },
  watch: {
    alreadyLiked: function(next) {
      if (next) {
        this.showHeart = true
        setTimeout(() => {
          this.showHeart = false
        }, 700)
      }
    },
  },
  methods: {
    like() {
      if (this.alreadyLiked) return

      ++this.taps
      if (this.taps === 1) {
        setTimeout(() => {
          if (this.taps > 1) {
            this.canBeLiked = false
            let likesCount = this.item.likes.length

            window.db.doc('entries/' + this.item.id).update({
              likes: firebase.firestore.FieldValue.arrayUnion(
                this.$store.state.users.user
              ),
              likesCount: ++likesCount,
            })
            this.taps = 0
          } else this.taps = 0
        }, 300)
      }
    },
    heartClick() {
      let likesCount = this.item.likes.length
      if (!this.canBeLiked || this.alreadyLiked) {
        this.canBeLiked = true

        window.db.doc('entries/' + this.item.id).update({
          likes: firebase.firestore.FieldValue.arrayRemove(
            this.$store.state.users.user
          ),
          likesCount: --likesCount,
        })
      } else {
        this.canBeLiked = false

        window.db.doc('entries/' + this.item.id).update({
          likes: firebase.firestore.FieldValue.arrayUnion(
            this.$store.state.users.user
          ),
          likesCount: ++likesCount,
        })
      }
    },
    enableGMode() {
      this.gModeTaps++
      if (this.gModeTaps >= 20 && !this.$store.state.users.moderator)
        this.$store.commit('SET_USERS_STATE', { moderator: true })
    },
    handleVisibility(value) {
      if (this.item.visible === value) return

      window.db.doc('entries/' + this.item.id).update({
        visible: value,
      })
    },
  },
}
</script>

<template>
  <div class="my-4 rounded border border-gray-400 shadow-md">
    <div
      class="flex flex-row justify-between rounded-t bg-white border-b border-gray-400 px-2 sm:px-4"
    >
      <div class="flex">
        <span class="my-auto truncate">
          <i class="far fa-clock mr-2" @click="enableGMode" /><timeago
            :datetime="item.submittedAt"
            :auto-update="60"
          />
        </span>
      </div>

      <div class="flex">
        <div
          class="h-full px-2 py-3 align-middle text-red-500 cursor-pointer hover:text-red-dark-700 active:text-red-800"
          @click="heartClick"
        >
          <i
            class="fa-heart"
            :class="{ far: !alreadyLiked, fas: alreadyLiked }"
          />
        </div>
        <span class="my-auto text-black">{{ item.likesCount }} likes</span>
      </div>
    </div>
    <div
      v-if="this.$store.state.users.moderator"
      class="py-2 px-4 bg-gray-200 text-white"
    >
      <button
        class="border-b-4 px-2 p-1 rounded-l"
        :class="{
          'bg-blue-500 border-blue-600': !item.visible,
          'bg-blue-300 border-blue-400 text-grey-400': item.visible,
        }"
        @click="handleVisibility(true)"
      >
        Show
      </button>
      <button
        class="border-b-4 px-2 p-1 rounded-r"
        :class="{
          'bg-blue-500 border-blue-600': item.visible,
          'bg-blue-300 border-blue-400 text-grey-400': !item.visible,
        }"
        @click="handleVisibility(false)"
      >
        Hide
      </button>
    </div>
    <div
      class="image bg-gray-200 rounded-b bg-black flex items-center justify-center select-none"
      :style="{ 'background-image': url }"
      @click="like"
    >
      <i v-if="showHeart" class="fas fa-heart heart text-white" />
    </div>
    <div
      v-if="item.message && item.message !== 'null' && item.message.length > 0"
      class="flex flex-row justify-between rounded-b bg-gray-100 border-t border-gray-400 px-2 sm:px-4"
    >
      <span class="my-auto text-black py-3 truncate">
        <i class="far fa-comment-alt fa-flip-horizontal mr-2" />{{
          item.visible ? item.message : '-'
        }}
      </span>
    </div>
  </div>
</template>

<style>
.image {
  height: 400px;
  background-repeat: no-repeat;
  background-position: center;
  background-size: contain;
}

.heart {
  animation: fave-heart 0.7s ease-out;
}

@keyframes fave-heart {
  0% {
    font-size: 1rem;
    opacity: 0;
  }
  30% {
    opacity: 1;
  }
  100% {
    font-size: 10rem;
    opacity: 0;
  }
}
</style>
